import React, { Fragment } from 'react';
import map from 'lodash/map';

import NavigationSubmenu from './desktop.submenu.jsx';

import { VisuallyHiddenP } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import LanguageSelector from 'zoomforth_component_lib/translations_language_selector_container.jsx';


const ManNavInner_ViewerVersion1 = ({
  menuItems,
  currentSubpage,
  submenuItemsBySubpageId,
  MenuItemComponent,
  SubmenuDropdownComponent
})=> (
  map(menuItems, (menuItem)=> (
    <div key={menuItem.id} className="nav-link-super-wrapper">
      <MenuItemComponent
        menuItem={menuItem}
        currentSubpage={currentSubpage}
        selected={
          menuItem.isPrimaryForSubpage &&
          menuItem.appAction.subpageId === currentSubpage.id
        }
      />

      {
        (
          menuItem.isPrimaryForSubpage &&
          menuItem.appAction.subpageId !== currentSubpage.id
        ) &&
          <SubmenuDropdownComponent
            menuItems={submenuItemsBySubpageId[menuItem.appAction.subpageId]}
          />
      }
    </div>
  ))
);


const MainNavigationUi_ViewerVersion1 = ({
  menuItems,
  currentSubpage,
  submenuItemsBySubpageId,
  MenuItemComponent,
  SubmenuDropdownComponent,
  isTranslationsEnabled,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange
})=> (
  <div key="main-navigation" className="navigation-links-container">
    {
      isTranslationsEnabled ?
        <Fragment>
          <div className="navigation-links-left">
            <ManNavInner_ViewerVersion1 
              menuItems={menuItems}
              currentSubpage={currentSubpage}
              submenuItemsBySubpageId={submenuItemsBySubpageId}
              MenuItemComponent={MenuItemComponent}
              SubmenuDropdownComponent={SubmenuDropdownComponent}
            />
          </div>

          <LanguageSelector
            currentIso={currentLanguageIso}
            defaultLanguageIso={defaultLanguageIso}
            appliedLanguages={appliedLanguages}
            onLanguageChange={onLanguageChange}
          />
        </Fragment>
      :
        <ManNavInner_ViewerVersion1 
          menuItems={menuItems}
          currentSubpage={currentSubpage}
          submenuItemsBySubpageId={submenuItemsBySubpageId}
          MenuItemComponent={MenuItemComponent}
          SubmenuDropdownComponent={SubmenuDropdownComponent}
        />
    }
  </div>
);

const ManNavInner_ViewerVersion2 = ({
  menuItems,
  currentSubpage,
  submenuItemsBySubpageId,
  MenuItemComponent,
  SubmenuDropdownComponent
})=> (
  <ul role="list" className="nav-links-list">
    {
      map(menuItems, (menuItem)=> (
        <li key={menuItem.id} className="nav-link-super-wrapper">
          <MenuItemComponent
            menuItem={menuItem}
            currentSubpage={currentSubpage}
            selected={
              menuItem.isPrimaryForSubpage &&
              menuItem.appAction.subpageId === currentSubpage.id
            }
          />

          {
            (
              menuItem.isPrimaryForSubpage &&
              menuItem.appAction.subpageId !== currentSubpage.id
            ) &&
              <SubmenuDropdownComponent
                menuItems={submenuItemsBySubpageId[menuItem.appAction.subpageId]}
              />
          }
        </li>
      ))
    }
  </ul>
);

const MainNavigationUi_ViewerVersion2 = ({
  menuItems,
  currentSubpage,
  submenuItemsBySubpageId,
  MenuItemComponent,
  SubmenuDropdownComponent,
  isTranslationsEnabled,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange
})=> (
  <nav
    key="main-navigation"
    aria-labelledby="globalNavLabel"
    className="navigation-links-container"
  >
    <VisuallyHiddenP id="globalNavLabel">
      Global
    </VisuallyHiddenP>

    {
      isTranslationsEnabled ?
        <Fragment>
          <div className="navigation-links-left">
            <ManNavInner_ViewerVersion2
              menuItems={menuItems}
              currentSubpage={currentSubpage}
              submenuItemsBySubpageId={submenuItemsBySubpageId}
              MenuItemComponent={MenuItemComponent}
              SubmenuDropdownComponent={SubmenuDropdownComponent}
            />
          </div>

          <LanguageSelector
            currentIso={currentLanguageIso}
            defaultLanguageIso={defaultLanguageIso}
            appliedLanguages={appliedLanguages}
            onLanguageChange={onLanguageChange}
          />
        </Fragment>
      :
        <ManNavInner_ViewerVersion2
          menuItems={menuItems}
          currentSubpage={currentSubpage}
          submenuItemsBySubpageId={submenuItemsBySubpageId}
          MenuItemComponent={MenuItemComponent}
          SubmenuDropdownComponent={SubmenuDropdownComponent}
        />
    }
  </nav>
);

const MainNavigationUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <MainNavigationUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <MainNavigationUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default ({
  MenuItemComponent,
  SubmenuItemComponent,
  SubmenuDropdownComponent,
  menuItems,
  currentSubpage,
  currentSubmenuItems,
  submenuItemsBySubpageId,
  lastClickedSubmenuItemId,
  isTranslationsEnabled,
  appliedLanguages,
  currentLanguageIso,
  defaultLanguageIso,
  onLanguageChange
}) => (
  <Fragment>
    <MainNavigationUi
      currentSubpage={currentSubpage}
      menuItems={menuItems}
      submenuItemsBySubpageId={submenuItemsBySubpageId}
      MenuItemComponent={MenuItemComponent}
      SubmenuDropdownComponent={SubmenuDropdownComponent}
      isTranslationsEnabled={isTranslationsEnabled}
      appliedLanguages={appliedLanguages}
      currentLanguageIso={currentLanguageIso}
      defaultLanguageIso={defaultLanguageIso}
      onLanguageChange={onLanguageChange}
    />

    {
      !!currentSubmenuItems &&
        <NavigationSubmenu
          key="submenu-navigation"
          SubmenuItemComponent={SubmenuItemComponent}
          currentSubpage={currentSubpage}
          lastClickedSubmenuItemId={lastClickedSubmenuItemId}
          menuItems={currentSubmenuItems}
        />
    } 
  </Fragment>
);
